import React from "react";
import type {MerchantOverviewResponse} from "../../api";

interface MerchantSettlementSummaryProps {
  overview: MerchantOverviewResponse;
}

export function MerchantSettlementSummary({
  overview,
}: MerchantSettlementSummaryProps): JSX.Element {
  const {balance, settlement} = overview;

  return (
    <section className="merchant-summary-grid" aria-label="Сводка по балансу">
      <article className="merchant-summary-card merchant-balance-card">
        <span className="meta-label">Текущий баланс</span>
        <strong className="merchant-balance-value mono">
          {balance.amount} {balance.currency}
        </strong>
        <span className="merchant-summary-hint">
          Сумма рассчитана сервером
        </span>
      </article>

      {settlement.mode === "debt" ? (
        <>
          <article className="merchant-summary-card">
            <span className="meta-label">Режим расчётов</span>
            <strong>Работа в долг</strong>
            <span className="merchant-summary-hint">
              Лимит долга: {settlement.debtLimit === null
                ? "не задан"
                : `${settlement.debtLimit} ${balance.currency}`}
            </span>
          </article>
          <article className="merchant-summary-card">
            <span className="meta-label">Состояние лимита</span>
            <strong className={settlement.limitExceeded ? "merchant-limit-alert" : "merchant-limit-ok"}>
              {settlement.limitExceeded
                ? `Лимит превышен на ${settlement.exceededBy} ${balance.currency}`
                : "В норме"}
            </strong>
            <span className="merchant-summary-hint">
              Лимит носит информационный характер
            </span>
          </article>
        </>
      ) : (
        <>
          <article className="merchant-summary-card">
            <span className="meta-label">Режим расчётов</span>
            <strong>Предоплата</strong>
            <span className="merchant-summary-hint">
              Допуск овердрафта: {settlement.overdraftAllowance} {balance.currency}
            </span>
          </article>
          <article className="merchant-summary-card">
            <span className="meta-label">В работе</span>
            <strong className="mono">
              {settlement.knownInFlight} {balance.currency}
            </strong>
            <span className="merchant-summary-hint">
              Уже учтено сервером
            </span>
          </article>
          <article className="merchant-summary-card">
            <span className="meta-label">Доступно для новых заявок</span>
            <strong className="mono">
              {settlement.availableToClaim} {balance.currency}
            </strong>
            {settlement.availabilityIsEstimate && (
              <span className="merchant-estimate-badge">Оценка</span>
            )}
            <span className="merchant-summary-hint">
              С учётом овердрафта
            </span>
          </article>
        </>
      )}
    </section>
  );
}
